//@flow
import groupFinTermsSearchActions from './groupFinTermsSearchActions';
import type {action} from "../../../../services/flowTypes/appFlowTypes";
import type {groupFinTermsSearch} from "../../../../services/flowTypes/dataFlowTypes";

type reducerAction = action;
const initialState = {};

const groupFinTermsSearchReducer = (state:groupFinTermsSearch = initialState, action:reducerAction) => {
  const newState = Object.assign({}, state);
  switch (action.type) {
    case groupFinTermsSearchActions.GROUP_FIN_TERMS_SEARCH_INIT_STATE_SET:
      return {...initialState, ...action.value};
    case groupFinTermsSearchActions.GROUP_FIN_TERMS_SEARCH_PROP_UPDATE:
      return {...newState, ...action.value};
    case groupFinTermsSearchActions.GROUP_FIN_TERMS_SEARCH_PROP_DELETE:
      for (let i=0; i < action.value.length; i++) {
        delete newState[action.value[i]];
      }
      return newState;
    default:
      return state;
  }
};

export default groupFinTermsSearchReducer;